import lrsAdapter from '../../helpers/lrs_adapter'
import getAxiosInstance from '../../helpers/get_axios_instance'

class NotificacionesChofer {
  static getNotificacionesChofer () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_notificacion_chofer?r=` +
      `{"orden": ["d:prioridad"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static submitNotificacion (notificacion, vencimiento, prioridad) {
    const axios = getAxiosInstance()
    const promise = axios.post(`consulta_notificacion_chofer`, `{"valores": {"notificacion": "${notificacion}", "fecha_vencimiento": "${vencimiento}", "prioridad": "${prioridad}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
  }

  static deleteNotificacion (fechaEmision) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`consulta_notificacion_chofer?r=` +
      `{"clave": {"fecha_emision": "${fechaEmision}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
  }
}

export default NotificacionesChofer
